import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as Icon } from '../Icon/Icon-D_Strav1.js';

const InlineAlertIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40021497__sc-1qb81di-0"
})(["", " ", " ", " ", " ", " ", " text-align:center;"], ({
  theme,
  $variant
}) => $variant === 'info' && css(["color:", ";"], theme.support.iconColor.info), ({
  theme,
  $variant
}) => $variant === 'error' && css(["color:", ";"], theme.support.iconColor.error), ({
  theme,
  $variant
}) => $variant === 'success' && css(["color:", ";"], theme.support.iconColor.success), ({
  theme,
  $variant
}) => $variant === 'warning' && css(["color:", ";"], theme.support.iconColor.warning), ({
  theme,
  $variant
}) => $variant === 'opportunity' && css(["color:", ";"], theme.support.iconColor.opportunity), ({
  theme,
  $variant
}) => $variant === 'loading' && css(["color:", ";"], theme.support.iconColor.loading));
InlineAlertIcon.displayName = 'InlineAlertIcon';
const InlineAlertMessage = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-40021497__sc-1qb81di-1"
})(["align-self:center;display:flex;column-gap:", ";color:", ";>{p,a,span,b,strong,em,ul,ol,abbr,cite{font:", ";}}", " ", " ", ""], ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.text.color.secondary, ({
  theme
}) => theme.font.text.small.default, isMobile(css(["font:", ";>{p,a,span,b,strong,em,ul,ol,abbr,cite{font:", ";}}column-gap:", ";"], ({
  theme
}) => theme.font.text.small.mobile, ({
  theme
}) => theme.font.text.small.mobile, ({
  theme
}) => theme.spacing.xxsmall.mobile)), ({
  $variant,
  theme
}) => $variant === 'error' && `
    color: ${theme.support.textColor.error};
  `, ({
  $variant,
  theme
}) => $variant === 'success' && `
    color: ${theme.support.textColor.success};
  `);
InlineAlertMessage.displayName = 'InlineAlertMessage';
const InlineAlertText = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40021497__sc-1qb81di-2"
})(["display:inline-flex;flex:1;font:", ";", ""], ({
  theme
}) => theme.font.text.small.default, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.small.mobile)));
const InlineAlertIconWrapper = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40021497__sc-1qb81di-3"
})(["display:flex;justify-content:center;align-items:center;height:", ";width:", ";", ""], ({
  theme
}) => theme.font.size[450], ({
  theme
}) => theme.font.size[450], isMobile(css(["height:", ";width:", ";"], ({
  theme
}) => theme.font.size[500], ({
  theme
}) => theme.font.size[500])));

export { InlineAlertMessage as I, InlineAlertIconWrapper as a, InlineAlertIcon as b, InlineAlertText as c };
//# sourceMappingURL=InlineAlert.styles-BxbStfgr.js.map
